export enum SortBy {
  CLIENT = 'client',
  CREATED_AT = 'created-at',
  STATUS = 'status',
  NAME = 'name'
}
